import { Injectable } from '@angular/core';
import { ApplicationRef } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  constructor(private appRef: ApplicationRef, private swUpdate: SwUpdate) {}

  update() {
    if (!this.swUpdate.isEnabled) return;

    const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
    const everyFiveMinutes$ = interval(5 * 60 * 1000);
    const checkOnceStable$ = concat(appIsStable$, everyFiveMinutes$);

    checkOnceStable$.subscribe(async () => {
      try {
        await this.swUpdate.checkForUpdate();
      } catch (err) {
        console.error('Error when checking for update', err);
      }
    });
  }
}
